import { render } from "./CustomCoverManager.vue?vue&type=template&id=10d8c934"
import script from "./CustomCoverManager.vue?vue&type=script&lang=js"
export * from "./CustomCoverManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__